/**
 * **A12 · The “I’m here” booth card** (Stream A, Paper.dc.html): stands at the booth, 4×6. What the
 * booth does, what to have ready, where to go after. The QR opens the family page's door on a
 * phone — the page's own address, the only thing it carries.
 */
import type { ReactNode } from 'react';
import { usePrinted } from './printed.js';
import { SheetPages } from './sheets.js';
import { usePhase } from '../shell/phase.js';

export function BoothCard(): ReactNode {
  // The family page's door on the public site, wherever SITE_ORIGIN says that is.
  const { siteOrigin } = usePhase();
  usePrinted('booth-card', siteOrigin !== null);
  if (siteOrigin === null) return <p>Reading where the family page lives…</p>;
  return (
    <SheetPages
      doc={{
        size: 'card',
        title: 'Volunteer check-in',
        sub: 'Welcome. Thank you for helping.',
        qr: `${siteOrigin}/family`,
        name: 'Booth table card',
        lead: (
          <>
            <p className="pr-big">I’m here</p>
            <p className="pr-sub">
              Have your QR or your name ready. The person at the desk does the rest.
            </p>
          </>
        ),
        lines: [
          { head: 'THEN' },
          { cells: ['Read and sign the waiver on the screen facing you'] },
          { cells: ['Take your tag from the printer'] },
          { cells: ['Walk to your area — the tag says where and who to ask for'] },
          { head: 'NO QR?' },
          { cells: ['Tell us your name, or your phone. Never turn back over a link.'] },
        ],
      }}
    />
  );
}
